export const Facebook = 'https://facebook.com/OculaFinanceAI'
export const X = 'https://x.com/OculaFinance'
export const Instagram = 'https://instagram.com/OculaFinance_'
export const LinkedIn = 'https://www.linkedin.com/company/ocula-finance'
export const Telegram = 'https://t.me/OculaFinance'